// External dependencies.
import $ from "jquery";

/**
 * RecipesCarousel class.
 *
 * @since 0.1.0
 * @class RecipesCarousel
 */
class RecipesCarousel {
    /**
     * Creates an instance of RecipesCarousel.
     * 
     * @since 0.1.0
     * @memberof RecipesCarousel
     */
    constructor() {
        this.carousel = document.querySelector( '#recipes-carousel' );
        this.initCarousel = this.initCarousel.bind( this );

        this.initCarousel();
    }

    /**
     * Inits the carousel.
     *
     * @since 0.1.0
     * @returns
     * @memberof RecipesCarousel
     */
    initCarousel() {
        if ( !this.carousel ) {
            return;
        }

        const settings = {
            adaptiveHeight: true,
            arrows: false,
            dots: true,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 1199,
                    settings: {
                        arrows: true,
                        prevArrow: `<img src="${window.app.theme_file_uri}/assets/images/icon-angle-left.png" class="ts-slider__arrow ts-slider__arrow--prev">`,
                        nextArrow: `<img src="${window.app.theme_file_uri}/assets/images/icon-angle-right.png" class="ts-slider__arrow ts-slider__arrow--next">`,
                        dots: false,
                        slidesToShow: 2,
                    },
                }
            ],
        };

        $( this.carousel ).slick( settings );
    }
}

export default RecipesCarousel;
